import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, _vm._g(_vm._b({
    tag: "component",
    staticClass: "v-color",
    class: _vm.classes,
    style: _vm.styles,
    attrs: {
      "aria-selected": _vm.selectable ? _vm.isSelected.toString() : null
    }
  }, 'component', Object.assign({}, _vm.attributes, _vm.$attrs), false), Object.assign({}, _vm.$listeners, {
    click: _vm.handleClick
  })));
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-7e144e21_0", {
    source: ".v-color[data-v-7e144e21]{background:0 0;background-color:var(--c-color);box-shadow:0 2px 3.5px rgba(0,0,0,.15);display:inline-flex;border-radius:50%;border:none;padding:0;position:relative;font-size:var(--c-size);height:1em;width:1em;transition:all var(--g-transition-duration)}.v-color[data-v-7e144e21]:before{border-radius:inherit;content:\"\";position:absolute;pointer-events:none;border:2px solid transparent;width:1.15em;height:1.15em;left:50%;top:50%;transform:translate(-50%,-50%);transition:inherit}.v-color--selectable[data-v-7e144e21]{cursor:pointer}.v-color--selected[data-v-7e144e21]:before{border-color:var(--g-color-gray-400)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-7e144e21";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };